import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import './index.scss';
import WorkOrderCardUI from './WorkOrderCardUI';
import DraggableModal from '@/components/DraggableModal';
import RtcPlayer from '@/components/VideoPlayer/RtcPlayer';
import {
  addGlobalEventListener,
  removeGlobalEventListener,
} from '@/utils/emit';

const WorkOrderDrawer = ({ isDrawerOpen }: { isDrawerOpen: boolean }) => {
  const workOrder = useSelector((state: any) => state.workOrder);
  const [videoModalInfo, setVideoModalInfo] = useState<any>({
    open: false,
    videoUrl: '',
    direction: '',
    vehicleName: '',
  });

  useEffect(() => {
    addGlobalEventListener('CHANGE_ISSUE_VIDEO_MODAL', (data) => {
      setVideoModalInfo({ ...data });
    });
    return () => {
      removeGlobalEventListener('CHANGE_ISSUE_VIDEO_MODAL', () => {});
    };
  }, []);

  return (
    <>
      <div className='workorder-drawer-container'>
        <div className='workorder-drawer-title'>
          <i className='title-icon'></i>
          <span>{`工单列表(${
            workOrder.issueList ? workOrder.issueList?.length : 0
          })`}</span>
        </div>

        <div className='workorder-drawer-content'>
          {workOrder.issueList && workOrder.issueList?.length > 0 ? (
            <>
              {workOrder.issueList?.map((item: any) => {
                return (
                  <WorkOrderCardUI
                    isDrawerOpen={isDrawerOpen}
                    key={item.issueNumber}
                    info={item}
                    magnifyVehicleName={videoModalInfo.vehicleName}
                  />
                );
              })}
            </>
          ) : (
            <div className='no-workorder'>
              <i className='no-workorder-icon'></i>
              <span>暂无工单</span>
            </div>
          )}
        </div>
      </div>

      {videoModalInfo.open && (
        <DraggableModal
          className='issue-video-modal'
          title={`实时视频：${videoModalInfo.direction}   车牌号：${videoModalInfo.vehicleName}`}
          onClose={() =>
            setVideoModalInfo({
              open: false,
              videoUrl: '',
              direction: '',
              vehicleName: '',
            })
          }
        >
          <RtcPlayer
            key={videoModalInfo.videoUrl}
            videoUrl={videoModalInfo.videoUrl}
            direction={videoModalInfo.direction!}
            handleRecordDelayValue={(val) => {
              // console.log(val);
            }}
          />
        </DraggableModal>
      )}
    </>
  );
};

export default React.memo(WorkOrderDrawer);
